import { AlertCellRenderer } from "./AlertCellRenderer"
import { getWearableStatusIcon } from "./utils"
import { IconColor } from "@/components/shared/Icon"
import { InputCellRenderer } from "@/components/shared/Table/TextCellRenderer"
import { Column } from "@/components/shared/Table/types"
import { WearableSensor } from "@/types/wearableSensors"
import { getBatteryChargeIcon } from "@/utils/index"

export const sharedWearablesColumns: Column<WearableSensor>[] = [
   {
      key: "macAddress",
      label: "ID",
      sortable: true,
      width: 325,
      renderCell: InputCellRenderer<WearableSensor>({
         field: "macAddress",
      }),
   },
   {
      key: "status",
      label: "Status",
      sortable: true,
      width: 210,
      minWidth: 96,
      renderCell: ({ row, ...rest }) =>
         InputCellRenderer<WearableSensor>({
            field: "status",
            iconName: getWearableStatusIcon(row.status),
            iconSize: "16",
            iconColor: IconColor.HONOLULU_BLUE,
            showOnlyOnView: true,
            onIconClick: () => {},
         })({ row, ...rest }),
   },
   {
      key: "batteryPercentage",
      label: "Charge",
      sortable: true,
      width: 210,
      minWidth: 72,
      renderCell: (args) =>
         InputCellRenderer<WearableSensor>({
            field: "batteryPercentage",
            iconName:
               args.row.batteryPercentage !== null
                  ? getBatteryChargeIcon(args.row.batteryPercentage)
                  : undefined,
            iconSize: "16",
            iconColor: IconColor.HONOLULU_BLUE,
            showOnlyOnView: true,
            onIconClick: () => {},
         })({
            ...args,
            value:
               args.row.batteryPercentage !== null
                  ? `${args.row.batteryPercentage}%`
                  : "",
         }),
   },
   {
      key: "alarm",
      label: "Alarm",
      sortable: true,
      width: 420,
      renderCell: ({ row }) =>
         AlertCellRenderer({
            alarm: row.alarm,
         }),
   },
]
